import { AppBar, Box, Checkbox, FormControlLabel, Paper, Stack, Toolbar, Typography } from "@mui/material";
import { PermissionId, getPermission } from "../../../../app/permissions";

interface PermissionsListProps {
  permissions: PermissionId[];
  addPermission: (permissionId: PermissionId) => void;
  removePermission: (permissionId: PermissionId) => void;
  statusPermission: (permissionId: PermissionId) => boolean;
}

const PermissionsList = (props: PermissionsListProps) => {
//   const dispatch = useAppDispatch();
//   const usersPermissionsIns = useSelector( selectUsersPermissionsIns );
  return <Paper sx={{ width: "98%", m: "1%" }} elevation={3}>
    <AppBar position="static" color={"primary"} sx={{ top: "auto", bottom: 0 }}>
        <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}> Permissões </Typography>
            <Box sx={{ flexGrow: 1 }} />
        </Toolbar>
    </AppBar>
    <Stack direction="row" sx={{mb: 0}}>
        {
            props.permissions.map((permissionId) => {
                const permission = getPermission(permissionId);
                const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    event.preventDefault();
                    console.log(event.target.name, event.target.checked);
                    if(event.target.checked) {
                        props.addPermission(permissionId);
                    } else {
                        props.removePermission(permissionId);
                    }
                };
                const checkbox = 
                    <Checkbox checked={props.statusPermission(permissionId)}
                            onChange={handleChange} name={permission.name} />;
                return <Paper key={permission.id} sx={{p: 2, alignItems: "left"}} elevation={10}>
                    <Stack direction="column" spacing={0} alignItems="center">
                        <FormControlLabel key={permission.id} control={checkbox} label={permission.name} /> 
                        <Typography variant="caption" sx={{ maxWidth: "300px", textAlign: "center" }}>{permission.description}</Typography>
                    </Stack>
                </Paper>;
            })
        }
    </Stack>
  </Paper>;
};

export default PermissionsList;